import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { DropdownToggle } from 'approot/shared/dropdown/dropdown.style';

type ClassRoomStudentAnswerDropdownProps = {
  $isSmall?: boolean;
};

export const ClassRoomStudentAnswerDropdown = styled(
  DropdownToggle
)<ClassRoomStudentAnswerDropdownProps>`
  min-width: ${rem(200)};
  min-height: ${({ $isSmall }) => ($isSmall ? rem(40) : rem(56))};
  width: auto;
`;
